__turbopack_context__.v({
  "root": "Tabs-module__CLDmSW__root",
  "segmented": "Tabs-module__CLDmSW__segmented",
});
